const DEFAULT_LANG = 'fr';

export const ITEM_EFFECT_ICON = '/img/effet_spell.png';

const pickLocalizedText = (value, lang = DEFAULT_LANG) => {
    if (!value) return '';
    if (typeof value === 'object') {
        return value[lang] || value.fr || value.en || '';
    }
    return String(value);
};

const effectNameSource = (item) => (!item ? null : (
    item.legendaryEffectName ||
    item.legendary_effect_name ||
    (item.legendaryEffect && (item.legendaryEffect.name || item.legendaryEffect.label)) ||
    null
));

const effectDescriptionSource = (item) => (!item ? null : (
    item.legendaryEffectDescription ||
    item.legendary_effect_description ||
    (item.legendaryEffect && (item.legendaryEffect.description || item.legendaryEffect.desc)) ||
    null
));

const isEmptySource = (source) => {
    if (!source) return true;
    if (typeof source === 'object') return Object.values(source).every((v) => !v);
    return !String(source);
};

/**
 * True when the item grants a spell — a legendary effect, or the passive on a
 * Dofus or Prysmaradite. Deliberately NOT `item.is_legendary`: that flag is the
 * game's "légendaire" marker and only 25 items carry it, while ~77 grant a
 * spell. Gating the tooltip row on the flag would drop every Dofus passive.
 */
export const hasItemEffect = (item) => (
    !isEmptySource(effectNameSource(item)) || !isEmptySource(effectDescriptionSource(item))
);

export const getItemEffectName = (item, lang = DEFAULT_LANG) =>
    pickLocalizedText(effectNameSource(item), lang);

export const getItemEffectDescription = (item, lang = DEFAULT_LANG) =>
    pickLocalizedText(effectDescriptionSource(item), lang);
